'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$101() {
  this.bdX = null;
  this.bdY = false;
}
export { $c_Lpresto_PrestoRouter$$anon$101 as $c_Lpresto_PrestoRouter$$anon$101 };
$p = $c_Lpresto_PrestoRouter$$anon$101.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$101;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$101() {
}
export { $h_Lpresto_PrestoRouter$$anon$101 as $h_Lpresto_PrestoRouter$$anon$101 };
$h_Lpresto_PrestoRouter$$anon$101.prototype = $p;
$p.c1 = (function() {
  if ((!this.bdY)) {
    this.bdX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bdY = true;
  }
  return this.bdX;
});
$p.P = (function() {
  return this.c1();
});
var $d_Lpresto_PrestoRouter$$anon$101 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$101, "presto.PrestoRouter$$anon$101", ({
  Nx: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$101 as $d_Lpresto_PrestoRouter$$anon$101 };
//# sourceMappingURL=presto.-Presto-Router$$anon$101.js.map
